import { useMemo } from 'react';

import _ from 'lodash';

import { FormBuilderMethodType, PrismWidgetType } from 'constants/formBuilder';
import { FormType } from 'constants/forms';

import { SIGNATURE_CKEDITOR_ONLY_KEYS } from '../../PrismFormEditor.pickers.constants';

import { buildSignatureLabel } from './utils';

const useSignatureEditorShim = request =>
  useMemo(() => {
    const closePicker = () => request.onClose?.();

    const execute = (method, payload = {}) => {
      if (method === FormBuilderMethodType.INSERT_REACT_COMPONENT) {
        const attrs = { widgetType: PrismWidgetType.SIGNATURE };
        Object.entries(payload).forEach(([k, v]) => {
          if (!SIGNATURE_CKEDITOR_ONLY_KEYS.has(k)) {
            attrs[k] = v;
          }
        });
        const resolvedLabel = buildSignatureLabel(attrs);

        if (resolvedLabel) {
          attrs.dataHellosignLabel = resolvedLabel;
        }

        request.onSave(attrs);

        return;
      }

      if (method === FormBuilderMethodType.DELETE_REACT_COMPONENT) {
        request.onDelete?.();
      }
    };

    return {
      formType: FormType.HTML,
      getData: () => request.getDocumentHtml?.() ?? '',
      setData: html => {
        request.setDocumentHtml?.(html);
        closePicker();
      },
      editing: { view: { focus: closePicker } },
      commands: {
        get: () => ({ execute: _.noop }),
      },
      config: {
        get: () => {
          return;
        },
      },
      execute,
    };
  }, [request]);

export default useSignatureEditorShim;
